import Vue from "vue";
import App from "./App.vue";
// Import your component
import SideBar from "./components/SideBar";
import vuetify from "./plugins/vuetify";
import router from "./router";
import VueApexCharts from "vue-apexcharts";
import VTooltip from "v-tooltip";
import jwt_decode from "jwt-decode";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDesktop } from "@fortawesome/free-solid-svg-icons";
import { faTable } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Toasted from "vue-toasted";
import VueMq from "vue-mq";
import axios from "axios";
import "leaflet/dist/leaflet.css";
import ProgressBar from "vuejs-progress-bar";
import VueThermometer from "vuejs-thermometer";
Vue.use(VueThermometer);
Vue.use(ProgressBar);

Vue.use(VTooltip);
Vue.use(VueMq, {
  breakpoints: {
    // default breakpoints - customize this
    sm: 450,
    md: 1250,
    lg: Infinity,
  },
});
Vue.mixin({
  data: () => {
    return {
      uniqueDataList: [],
      previousUniqueId: "",
    };
  },
  methods: {
    ParameterGroupAssign(parameter_group_object) {
      console.log("paramteer iddddd", parameter_group_object);
      let Device_parameter_data = {};
      let Device_id = null;
      Device_id = parameter_group_object[0].parameter_list[0].device_id;
      console.log("Device_id manish podugu", Device_id);
      for (let index = 0; index < parameter_group_object.length; index++) {
        for (
          let index1 = 0;
          index1 < parameter_group_object[index].parameter_list.length;
          index1++
        ) {
          console.log(
            "parameter_group_object[index].parameter_list[index1].actual_name",
            parameter_group_object[index].parameter_list[index1].actual_name
          );
          let parameter_name =
            parameter_group_object[index].parameter_list[index1].actual_name;
          let parameter_id =
            parameter_group_object[index].parameter_list[index1].id;
          Device_parameter_data[parameter_name] = parameter_id;
          console.log(
            "Device_parameter_dataDevice_parameter_data",
            Device_parameter_data
          );
        }
      }
      console.log("parametres each-->>", Device_parameter_data);

      return [Device_parameter_data, Device_id];
    },
    clearcrumbsdict() {
      sessionStorage.setItem("crumbs_dict", JSON.stringify({}));
    },
    DateSort: function(items, index, isDesc) {
      if (index[0] == "perform_date") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(b[index]) - new Date(a[index]);
          } else {
            return new Date(a[index]) - new Date(b[index]);
          }
        });
      } else if (index[0] != "perform_date") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            if (typeof a[index] == "number") {
              return b[index] - a[index];
            } else {
              console.log("checking incase not perform", a[index], b[index]);
            }
          } else {
            if (typeof a[index] == "number") {
              return a[index] - b[index];
            } else {
              console.log("checking incase not perform", a[index], b[index]);
            }
          }
        });
      }

      return items;
    },

    getImgUrl1(pic) {
      return require("@/assets/" + pic);
    },
    compareObjects(object1, object2, key) {
      console.log("checking beofr inserting",object1, object2, key);
      let obj1 = null
      let obj2=null
      if (key)
      {
        obj1 = object1[key].toUpperCase() ;
        obj2 = object2[key].toUpperCase() ; 
      }


      if (obj1 < obj2) {
        return -1;
      }
      if (obj1 > obj2) {
        return 1;
      }
      return 0;
    },
    noteLastAPICallTime: () => {
      sessionStorage.setItem(
        "lastCall",
        (new Date().getTime() / 1000).toFixed()
      );
    },
  },
});

Vue.use(Toasted);
library.add(faDesktop);
library.add(faTable);
library.add(faAngleRight);
library.add(faUser);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

// Globally register your component
Vue.component("side-bar", SideBar);
Vue.component("apexchart", VueApexCharts);
var configValue = null;
async function logout(logoutType)
  {
    let config = {
      method: "post",
      url: `${configValue.backend_url}/expiredlogout`,
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
      data: {
        logout: sessionStorage.getItem("logintime"),
        activeUser: sessionStorage.getItem("activeUser"),
        logoutType: logoutType
      },
    };

     await axios(config)
      .then(function(response) {
        console.log("logging out --->>>", response);

      })
      .catch(function(error) {
        console.log(error);
      });
      setTimeout(function() {
        console.log("Delayed message after 3 seconds");
      }, 3000); // 3000 milliseconds = 3 seconds
      sessionStorage.clear();

      router.push("/login");

  }
fetch(process.env.BASE_URL + "config.json")
  .then((response) => response.json())
  .then((config) => {
    Vue.prototype.$config = config;
    configValue = config;
    Vue.prototype.$crumbs_dict = {};
    new Vue({
      vuetify,
      VueApexCharts,
      router,
      render: (h) => h(App),
    }).$mount("#app");
  });

 setInterval(() => {
  let decoded = jwt_decode(sessionStorage.getItem("token"));
  let tokenValidityIsSeconds = decoded.exp - decoded.iat;
  let currentTimeStamp = (new Date().getTime() / 1000).toFixed();
  let lastCallTimeStamp = sessionStorage.getItem("lastCall");
  let expiryTimeStamp = decoded.exp;

  console.log("clearing session and going to login", configValue);

  if (currentTimeStamp - lastCallTimeStamp > tokenValidityIsSeconds) {
    // console.log("checking time", tokenValidityIsSeconds);
    logout(configValue.user_logout_statement)
  }else if (currentTimeStamp - lastCallTimeStamp >= configValue.inactive_logout_duration) {
    logout(configValue.inactive_logout_statement)
  }else if (
    expiryTimeStamp - currentTimeStamp <= 120 &&
    currentTimeStamp - lastCallTimeStamp < tokenValidityIsSeconds
  ) {
    console.log("fetching new token",currentTimeStamp - lastCallTimeStamp);
    let config = {
      method: "post",
      url: `${configValue.backend_url}/refresh`,
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("refreshToken")}`,
      },
    };
    axios(config)
      .then(function(response) {
        if (response && response.data && response.data.access_token) {
          sessionStorage.removeItem("token");
          sessionStorage.setItem("token", response.data.access_token);
        }
      })
      .catch(function(error) {
        // logout()
        console.log(error);
      });
  }
}, 60000);

